import React from "react";

// Form container style
import "react-phone-input-2/lib/style.css";
import { withRouter } from "react-router-dom";
import {  Input, Button, Checkbox, Modal, message, Select } from "antd";
import { Icon, Form } from "@ant-design/compatible";
import { AllCountryDetails } from "./country";
import { GoogleMap, LoadScript, Marker, Autocomplete } from '@react-google-maps/api';


// Redux
import { connect } from "react-redux";
import {
  signupMerchant,
  checkEmailAvailability,
  checkPhoneAvailability,
} from "../../../redux/actions/authActions";

import "./index.scss";
import "../index.scss";
import strings from "../../../strings";
import { formatGoogleAddress } from "../../../utils/formatAddressFromApi";

const FormItem = Form.Item;

const user = {
  full_name: "",
  email: "",
  phoneNumber: "",
  businessName: "",
  verified: true,
};

const libraries = ['places'];
class Signup extends React.PureComponent {
  state = {
    loading: false,
    country: null,
    state: "",
    countries: null,
    countryCodes: null,
    businessTypes: [
      { id: 1, type: strings.foodAndDrinks },
      { id: 2, type: strings.salonAndBeauty },
      { id: 3, type: strings.fashionAndAccessories },
      { id: 4, type: strings.gymAndFitness },
      { id: 5, type: strings.travelAndHotel },
      { id: 6, type: strings.homeAndGifts },
      { id: 7, type: strings.washingAndCleaning },
      { id: 8, type: strings.gadgetsAndElectronics },
      { id: 9, type: strings.groceries },
      { id: 10, type: strings.others },
      { id: 11, type: strings.photography },
      { id: 12, type: strings.bookstore },
      { id: 13, type: strings.healthcare },
    ],
    isChecked: false,
    isEmailLoading: false,
    isPhoneLoading: false,
    utm_source: "",
    refcode: "",
    autocomplete: null,
    address_line1: null,
    longitude: null,
    latitude: null,
    state: null
  };

  componentDidMount() {
    const { form, countryData, formData } = this.props;

    // Load persisted form data
    if (formData) {
      form.setFieldsValue(formData);
      this.setState({
        address_line1: formData.address_line1 || null,
        isChecked: formData.isChecked || false
      });
    }

    // fetch all countries with their currencies and calling codes 
    
    // fetch(`https://restcountries.com/v2/all`)
    //   .then(res => res.json())
    //   .then(res => {
    //     console.log("res", res);
    //     let country = res.find(
    //       country =>
    //         country.alpha2Code.toLowerCase() ===
    //         countryData.countryCode.toLowerCase()
    //     );

    //     // console.log({ res, country });

    //     this.setState({ country });
    //   });
    this.setCountryDetails();
    // Set Referral Code Input Field if present
    const url = this.props.location.search;

    const referral_info = url && url.split("&"); // expecting  ["?refcode=2234", "utm_source=ig"]

    // console.log(referral_info.filter(item => item.includes("ref_code")));

    // const refcode = referral_info.length && referral_info[0].split("?")[1];
    const refcode =
      referral_info.length &&
      referral_info.filter(item => item.includes("ref_code"));

    const utm_source =
      referral_info.length &&
      referral_info.filter(item => item.includes("utm_source"));

    // console.log({ refcode, utm_source });

    if (refcode.length) {
      form.setFieldsValue({
        hearAbout: "I have a referral code",
        ref_code: refcode[0].split("=")[1],
      });
    }

    if (utm_source.length) {
      this.setState({
        utm_source: utm_source[0].split("=")[1],
      });
    }

    if (refcode && refcode.length) {
      this.setState({ refcode: refcode[0].split("=")[1] });
    }
  }

  setCountryDetails = () => {
    const { countryData } = this.props;

    let country = AllCountryDetails.find(
      country =>
        country.alpha2Code.toLowerCase() ===
        countryData.countryCode.toLowerCase()
    );

    this.setState({ country });
  }

  toggleLoading = () => {
    this.setState({ loading: !this.state.loading });
  };

  // Function to persist form data on field changes
  handleFieldChange = (changedFields) => {
    const { updateFormData } = this.props;
    if (updateFormData) {
      updateFormData('signupData', changedFields);
    }
  };

  // Handle checkbox change and persist it
  handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    this.setState({ isChecked });
    this.handleFieldChange({ isChecked });
  };



  // TODO: Submit registration form
  handleSubmit = async e => {
    e.preventDefault();
    const { form, signupMerchant, phone, personalDataFields, onSignupSuccess } = this.props;
    const { country, state, utm_source, refcode, longitude, latitude } = this.state;

    try {
      this.setState({ loading: true });

      const values = await form.validateFields();

      // filter out business type with business typd id
      let business_type = this.state.businessTypes.filter(
        type => Number(personalDataFields.business_type_id) === type.id
      );
      business_type = business_type[0].type;

      // let contact_number =
      //   values.contact_number[0] == "+"
      //     ? values.contact_number
      //     : `+${values.contact_number}`;

      // contact_number = contact_number.split(" ").join("");

      const payload = {
        ...values,
        ref_code: values.hearAbout === "I have a referral code" ? values.ref_code : values.hearAbout,
        ...{ business_type },
        ...personalDataFields,
        contact_number: phone,
        country: country.name,
        currency: country.currencies[0].code,
        state,
        longitude,
        latitude
      };

      if (utm_source) {
        payload.signup_source = utm_source;
      }

      // return console.log(payload);

      signupMerchant({
        ...payload,
        state,
        country,
      }).then(res => {
        this.setState({ loading: false });
        const { status } = res;

        // check if merchant registration was successful
        this.setState({ loading: false });
        if (status && status === 200) {
          const userData = res.data?.data || res.data || {
            id: Date.now(),
            email: values.email,
            first_name: values.full_name?.split(' ')[0] || '',
            last_name: values.full_name?.split(' ').slice(1).join(' ') || '',
            subscription_plan: 'Free',
            currency: country?.currencies?.[0]?.code || 'USD',
            ...values
          };

          message.success(strings.accountCreatedSuccessful);
          this.props.form.resetFields();

          if (onSignupSuccess && typeof onSignupSuccess === 'function') {
            onSignupSuccess(userData);
          } else {
            this.props.history.push("/d/transactions/today/report");
          }
        } else {
          this.setState({ loading: false });
          
          // Extract and display error messages from API response
          let errorMessages = [];
          
          if (res.message?.full_messages && Array.isArray(res.message.full_messages)) {
            // Use full_messages array if available
            errorMessages = res.message.full_messages;
          } else if (res.message) {
            // If message is an object with field errors, extract them
            if (typeof res.message === 'object') {
              Object.entries(res.message).forEach(([key, value]) => {
                if (key !== 'full_messages' && Array.isArray(value)) {
                  value.forEach(msg => errorMessages.push(`${key} ${msg}`));
                } else if (typeof value === 'string') {
                  errorMessages.push(value);
                }
              });
            } else {
              // If message is a string, use it directly
              errorMessages.push(res.message);
            }
          } else {
            errorMessages.push("Failed to create account. Please try again.");
          }
          
          // Show each error as a message notification
          errorMessages.forEach(msg => {
            message.error(msg, 5); // 5 seconds duration
          });
        }
      }).catch(error => {
        this.setState({ loading: false });
        console.error("Signup error:", error);
        
        // Extract error messages from API response
        const errorResponse = error.response?.data;
        let errorMessages = [];
        
        if (errorResponse?.message?.full_messages && Array.isArray(errorResponse.message.full_messages)) {
          // Use full_messages array if available
          errorMessages = errorResponse.message.full_messages;
        } else if (errorResponse?.message) {
          // If message is an object with field errors, extract them
          if (typeof errorResponse.message === 'object') {
            Object.values(errorResponse.message).forEach(value => {
              if (Array.isArray(value)) {
                errorMessages.push(...value);
              } else if (typeof value === 'string') {
                errorMessages.push(value);
              }
            });
          } else {
            // If message is a string, use it directly
            errorMessages.push(errorResponse.message);
          }
        } else {
          // Fallback to generic error
          errorMessages.push(error.message || "Failed to create account. Please try again.");
        }
        
        // Show validation errors with message notification
        if (errorMessages.length > 0) {
          errorMessages.forEach(msg => {
            message.error(msg);
          });
        }
      })      
    } catch (error) {
      this.setState({ loading: false });
      console.log(error);
    }

    form.validateFields((err, values) => {
      this.setState({ loading: false });
      if (err) return;

      this.setState({ loading: true });
    });
  };

  selectCountry(val) {
    this.setState({ country: val });
  }

  selectRegion(val) {
    this.setState({ state: val });
  }



  onLoad = (autocomplete) => {
    this.setState({ autocomplete });
  };

  handleAddressChange = (e) => {
    const value = e.target.value;
    this.setState({ address_line1: value });
    this.props.form.setFieldsValue({ address_line1: value });
    // Persist the address change
    this.handleFieldChange({ address_line1: value });
  };

  handlePlaceSelect = () => {
    if (this.state.autocomplete) {
      const place = this.state.autocomplete.getPlace();
      if (place && place.formatted_address) {
        this.setState({ address_line1: place.formatted_address });
        this.props.form.setFieldsValue({ address_line1: place.formatted_address });
      }
    }
  };

  renderInput = () => {
    const { address_line1 } = this.state;

    return (
      <Input
        value={address_line1}
        size="large"
        onChange={this.handleAddressChange}
        type="text"
        placeholder={strings.addressLine1}
        style={{ width: "100%" }}
        prefix={<Icon type="environment" style={{ color: "rgba(0,0,0,.25)" }} />}
      />
    );
  };
  // phone_number

 

  render() {
    // Passed from the Form.create() HOC below {ln: 193}
    const { getFieldDecorator, setFieldsValue } = this.props.form;

    const { loading, address_line1, autocomplete } = this.state;
    const onPlaceChanged = () => {
      const { form } = this.props;
      const { autocomplete } = this.state;
      const { setFieldsValue } = form;
      if (autocomplete !== null) {
        const place = autocomplete.getPlace();
        const location = place.geometry.location;
  
  
        const formatedAdress = formatGoogleAddress(place.address_components);
  
        // setAddress_line1(formatedAdress.addressLine1);
        // setAddress_line2(formatedAdress.addressLine2);
        // setPostal_code(formatedAdress.postalCode);
        // setState(formatedAdress.state);
        // setCountry(formatedAdress.country);
  
        this.setState({
          address_line1: formatedAdress.addressLine1
        });
  
        setFieldsValue({
          postcode: formatedAdress.postalCode,
          state: formatedAdress.state,
          country: formatedAdress.country,
          address_line1: formatedAdress.addressLine1,
          address_line2: formatedAdress.addressLine2
        });
  
        this.setState({
          longitude: location.lng(),
          latitude: location.lat(),
          state: formatedAdress.state,
        })
  
      } else {
        console.log('Autocomplete is not loaded yet!');
      }
    };

    return (
      <div className="" style={{ maxWidth: "500px" }}>
        <div className="">
          <Form layout="vertical" onSubmit={this.handleSubmit}>
            {/* Address Line 1*/}
            {/* {autocomplete && <FormItem>
              {getFieldDecorator("address_line1", {
                rules: [
                  {
                    required: true,
                    message: strings.pleaseEnterAddress,
                  },
                ],
              })(
                <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_KEY} libraries={libraries}>
                <div>
                  {<Autocomplete onLoad={this.onLoad} onPlaceChanged={onPlaceChanged}>
                    <Input 
                      // placeholder="address line1"
                      value={address_line1}
                      // name="address_line1"
                      size="large"
                      onChange={(e)=>{
                        this.setState({address_line1: e.target.value});
                        setFieldsValue({
                          address_line1: e.target.value
                        })
                      }}
                      type="text"
                      // placeholder="Search for a place"
                      placeholder={strings.addressLine1}
                      style={{ width: '100%'}}
                      // ref={inputRef}
                      prefix={
                        <Icon
                          type="environment"
                          style={{ color: "rgba(0,0,0,.25)" }}
                        />
                      }
                    />
                  </Autocomplete>}
                </div>
              </LoadScript> 
              )}
            </FormItem>}

            {!autocomplete && <FormItem>
              {getFieldDecorator("address_line1", {
                rules: [
                  {
                    required: true,
                    message: strings.pleaseEnterAddress,
                  },
                ],
              })( 
                
                <Input 
                // placeholder="address line1"
                value={address_line1}
                // name="address_line1"
                size="large"
                onChange={(e)=>{
                  this.setState({address_line1: e.target.value});
                  setFieldsValue({
                    address_line1: e.target.value
                  })
                }}
                type="text"
                // placeholder="Search for a place"
                placeholder={strings.addressLine1}
                style={{ width: '100%'}}
                // ref={inputRef}
                prefix={
                  <Icon
                    type="environment"
                    style={{ color: "rgba(0,0,0,.25)" }}
                  />
                }
              />
              
              )}
            </FormItem>} */}
            <Form.Item>
              {getFieldDecorator("address_line1", {
                rules: [{ required: true, message: strings.pleaseEnterAddress }],
                    })(
                autocomplete ? (
                  <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_KEY} libraries={libraries}>
                    <Autocomplete onLoad={this.onLoad} onPlaceChanged={this.handlePlaceSelect}>
                      {this.renderInput()}
                    </Autocomplete>
                  </LoadScript>
                ) : (
                  this.renderInput()
                )
              )}
            </Form.Item>
            {/* =========Address Line 1 */}

            {/* Address Line 2*/}
            <FormItem>
              {getFieldDecorator("address_line2")(
                <Input
                  size="large"
                  prefix={
                    <Icon
                      type="environment"
                      style={{ color: "rgba(0,0,0,.25)" }}
                    />
                  }
                  placeholder={strings.addressLine2}
                />
              )}
            </FormItem>

            <FormItem style={{ marginBottom: "0" }}>
              {getFieldDecorator("postcode", {
                rules: [
                  {
                    required: false,
                    message: strings.pleaseEnterPostCode,
                  },
                ],
              })(<Input placeholder={strings.postCode} size="large" />)}
            </FormItem>

            {/* Password Input */}
            <FormItem>
              {getFieldDecorator("password", {
                rules: [
                  {
                    message: strings.pleaseEnterPassword,
                    required: true,
                  },
                  {
                    min: 6,
                    message: strings.passwordMustBe6Characters,
                  },
                ],
              })(
                <Input.Password
                  size="large"
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  style={{ marginTop: "20px" }}
                  type="password"
                  placeholder={strings.choosePassword}
                />
              )}
            </FormItem>

            {/* Confirm Password Input */}
            <FormItem>
              {getFieldDecorator("confirmPassword", {
                rules: [
                  {
                    message: "Please confirm your password",
                    required: true,
                  },
                  {
                    validator: (rule, value, callback) => {
                      const { getFieldValue } = this.props.form;
                      if (value && value !== getFieldValue('password')) {
                        callback('Passwords do not match');
                      } else {
                        callback();
                      }
                    },
                  },
                ],
              })(
                <Input.Password
                  size="large"
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  type="password"
                  placeholder="Confirm Password"
                />
              )}
            </FormItem>
            {/* ======Password */}

            {/* ====Referral Code===*/}
            <FormItem label={strings.howDidYouHearLoystar}>
              {getFieldDecorator("hearAbout", {
                rules: [{ required: true, message: "Please select how you heard about us" }]
              })(
                <Select size="large" placeholder="Select Source">
                  <Select.Option value="Google">Google</Select.Option>
                  <Select.Option value="ChatGPT">ChatGPT</Select.Option>
                  <Select.Option value="A Friend">A Friend</Select.Option>
                  <Select.Option value="LinkedIn">LinkedIn</Select.Option>
                  <Select.Option value="Facebook">Facebook</Select.Option>
                  <Select.Option value="Instagram">Instagram</Select.Option>
                  <Select.Option value="Business Community">Business Community</Select.Option>
                  <Select.Option value="I have a referral code">I have a referral code</Select.Option>
                </Select>
              )}
            </FormItem>

            {this.props.form.getFieldValue("hearAbout") === "I have a referral code" && (
              <FormItem>
                {getFieldDecorator("ref_code", {
                  rules: [{ required: true, message: "Please enter your referral code" }]
                })(
                  <Input
                    size="large"
                    type="text"
                    placeholder={strings.referralCode}
                  />
                )}
              </FormItem>
            )}


            {/* ====Referral Code===*/}

            <div style={{ marginBottom: "24px" }}>
              <Checkbox
                onChange={this.handleCheckboxChange}
                checked={this.state.isChecked}
              >
                {strings.byClickingTheButton}
                <a
                  href="https://loystar.co/legal/"
                  target="_blank"
                  rel="noopener"
                >
                  {strings.termsAndSevice}
                </a>
              </Checkbox>
            </div>

            <div className="control-buttons" style={{ display: "flex", gap: "12px", alignItems: "stretch", marginTop: "16px" }}>
              <Button
                size="large"
                onClick={() => this.props.previous()}
                style={{ minWidth: "80px" }}
              >
                Back
              </Button>

              <Button
                className="submit-btn"
                type="primary"
                size="large"
                htmlType="submit"
                loading={loading}
                disabled={!this.state.isChecked}
                style={{ flex: 1 }}
              >
                {loading ? strings.wereCreatingAccount : strings.proceed}
              </Button>
            </div>

            {/* <div
              className="form-utils__container"
              style={{ justifyContent: "center" }}
            >
              <Link to="/signin">Sign in</Link>
            </div> */}
          </Form>
        </div>
      </div>
    );
  }
}
const SignupForm = Form.create({
  mapPropsToFields(props) {
    // Load persisted data into form fields
    const { formData } = props;
    
    if (formData) {
      const fields = {};
      Object.keys(formData).forEach(key => {
        if (formData[key] !== undefined && formData[key] !== null) {
          fields[key] = Form.createFormField({
            value: formData[key],
          });
        }
      });
      return fields;
    }
    
    // Fallback to default user object values if no formData
    return {
      full_name: Form.createFormField({
        value: user.full_name ? user.full_name : "",
      }),
      businessName: Form.createFormField({
        value: user.businessName ? user.businessName : "",
      }),
      phoneNumber: Form.createFormField({
        value: user.phoneNumber ? user.phoneNumber : "",
      }),
      email: Form.createFormField({
        value: user.email ? user.email : "",
      }),
    };
  },
  onValuesChange(props, changedValues, allValues) {
    // Persist form data on every field change
    if (props.updateFormData) {
      props.updateFormData('signupData', changedValues);
    }
  },
})(props => <Signup {...props} />);

export default connect(null, {
  signupMerchant,
  checkPhoneAvailability,
  checkEmailAvailability,
})(withRouter(SignupForm));
